<template>
    <div id="app">
        <Header />
        <div class="minh">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive">
                    <!-- 这里是会被缓存的视图组件 -->
                </router-view>
            </keep-alive>

            <router-view v-if="!$route.meta.keepAlive">
                <!-- 这里是不会被缓存的视图组件 -->
            </router-view>
        </div>
        <Footer />
        <Board />
    </div>
</template>
<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import Board from '@/components/msgBoard.vue'
export default {
    name: 'Home',
    components: {
        Header,
        Footer,
        Board
    }
}
</script>

<style lang="scss">
.minh {
    min-height: 60vh;
}
</style>
